import { FC, useCallback, useEffect, useRef, useState } from 'react';

import * as styles from './styles';

interface BackgroundImageProps {
  url: string;
  filter?: string;
  width?: number;
  height?: number;
}

const BackgroundImage: FC<BackgroundImageProps> = ({
  url,
  filter,
  width = 1920,
  height = 1080
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const canvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  const onLoad = useCallback(() => {
    if (canvasRef.current && imgRef.current) {
      setIsLoaded(true);

      const context = canvasRef.current.getContext('2d');
      if (context) {
        if (filter) {
          context.filter = filter;
        }
        context.drawImage(
          imgRef.current,
          0,
          0,
          imgRef.current.width,
          imgRef.current.height,
          0,
          0,
          width,
          height
        );
      }
    }
  }, [imgRef, filter, width, height]);

  useEffect(() => {
    setIsLoaded(false);
  }, [url]);

  return (
    <div css={styles.container}>
      <canvas ref={canvasRef} css={styles.canvas} width={width} height={height}></canvas>
      {!isLoaded && (
        <img ref={imgRef} src={url} alt={''} css={styles.image} onLoad={onLoad} />
      )}
    </div>
  );
};

export default BackgroundImage;
